/* eslint-disable complexity */
const $ = require("jquery");
const _ = require("underscore");
const gtm = require("common/analytics/google-tagmanager");
const modalWindow = require("site/mobile/modal-window");
const checkoutChangePage = require("site/mobile/checkout/page-changer");

let $page;
let $popup;
let $password;

const category = "verify_account_modal";
function trackModalShow (network) {
  return gtm.trackEvent({
    category,
    property: category,
    action: "show",
    label: network
  });
}

function trackModalPasswordFocus () {
  return gtm.trackEvent({
    category,
    property: "password_field",
    action: "focus"
  });
}

function trackModalSubmitClick () {
  return gtm.trackEvent({
    category,
    property: "verify_button",
    action: "click"
  });
}

function trackModalCancelClick () {
  return gtm.trackEvent({
    category,
    property: "cancel_button",
    action: "click"
  });
}

function closePopup () {
  $popup.popup("close");
}

function login ({ googleIdToken, variant }) {
  var credentials = {
    googleIdToken,
    password: $password.val(),
    persistentLogin: true
  };

  $.ajax({
    method: "POST",
    url: "/ajax/site/login",
    data: credentials,
    success: _.bind(function (response) {
      if (
        response.result === "ACCOUNT_AUTHENTICATED" ||
        response.result === "PROFILE_AUTHENTICATED"
      ) {
        if (variant === "checkout") {
          var currentUri = window.window.location.href.split("?");
          checkoutChangePage("checkout-page", currentUri[1], {
            allowtransition: true
          });
          modalWindow.hide();
        } else {
          window.location.href = "/";
        }
      } else if (response.result === "CHANNEL_MISMATCH") {
        $page.find(".error-channel-message").popup("open");
      } else {
        $page.find(".error-verify-password").popup("open");
      }
    }, this),
    error: _.bind(function () {
      $page.find(".error-verify-password").popup("open");
    }, this),
    complete () {
      modalWindow.hide();
    }
  });
}

module.exports = function ({
  googleIdToken,
  pageVariant: variant,
  handleRedirection
} = {}) {
  trackModalShow("google");

  $page = $.mobile.pageContainer.pagecontainer("getActivePage");
  $popup = $("#login-verify-account-popup-checkout-onepage-popup .login-verify-account-popup");

  $password = $popup.find(".password");

  var $form = $popup.find("form");
  var $button = $popup.find(".submit.ui-btn");
  const $text = $form.find("> p");

  $popup.find(".close a").on("click", closePopup);

  $form.find(".close").on("click", trackModalCancelClick);
  $password.on("focus", trackModalPasswordFocus);

  $button.on("click", function () {
    closePopup();
    modalWindow.show();
    trackModalSubmitClick();
    login({
      googleIdToken,
      variant,
      handleRedirection
    });
  });

  const updatedText = $text.text().replace("Facebook", "Google").trim();
  $text.text(updatedText);
  $popup.popup("open");
};
